import { combineReducers } from 'redux';
// reducers
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth.reducer';
import modalsReducer from './modal.reducer';
import profileReducer from './profile.reducer';
import stepRegistrationReducer from './step-registration.reducer';
import activityReducer from './activity.reducer';
import roleListReducer from './role-list.reducer';
import studiesReducer from './studies.reducer';
import studyReducer from './study.reducer';
import applicationReducer from './application.reducer';
import locationReducer from './location.reducer';
import personnelReducer from './personnel.reducer';

/*
 * Creates the main reducer with the dynamically injected ones
 * @param {object} injectedReducers - list of reducers
 * @returns {Reducer<any> | Reducer<any, AnyAction>}
 */

const appReducer = combineReducers({
  form: formReducer,
  authState: authReducer,
  modalState: modalsReducer,
  profileState: profileReducer,
  roleList: roleListReducer,
  stepRegistration: stepRegistrationReducer,
  activity: activityReducer,
  studies: studiesReducer,
  studyState: studyReducer,
  applicationState: applicationReducer,
  locationState: locationReducer,
  personnelState: personnelReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'GLOBAL_CLEAR_STATE') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
